
      import API from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../web/myagent/app/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../web/myagent/app/node_modules/css-loader/dist/cjs.js!./Message.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../web/myagent/app/node_modules/css-loader/dist/cjs.js!./Message.css";
       export default content && content.locals ? content.locals : undefined;
